// Centralized legal content for ANAIZA SHOP.
// Each entry: { slug, title, eyebrow, description, sections: [{h, p}] }
// Edit content here to update everywhere.

import { COMPANY, fullAddress } from "./company";

const C = COMPANY;
const ADDR = fullAddress();

export const LEGAL_PAGES = {
  "termeni-si-conditii": {
    title: "Termeni și Condiții",
    eyebrow: "Document juridic",
    description: "Termenii și condițiile de utilizare a magazinului online ANAIZA SHOP. Reguli, obligații și drepturi.",
    sections: [
      {
        h: "1. Părțile contractante",
        p: `Vânzător: ${C.legal_name}, cu sediul în ${ADDR}, înregistrată la Registrul Comerțului sub nr. ${C.reg_com}, CUI ${C.cif}, denumită în continuare "ANAIZA SHOP" sau "Vânzătorul".\n\nCumpărător: orice persoană fizică sau juridică ce plasează o comandă pe site-ul anaiza-shop.ro, denumită în continuare "Cumpărătorul" sau "Clientul".`,
      },
      {
        h: "2. Obiectul contractului",
        p: `Obiectul contractului îl reprezintă vânzarea-cumpărarea produselor prezentate pe site-ul ANAIZA SHOP. Prin plasarea unei comenzi, Cumpărătorul acceptă în totalitate prezentele Termeni și Condiții. Comanda are valoare de contract la distanță, conform OUG 34/2014 privind drepturile consumatorilor.`,
      },
      {
        h: "3. Prețuri și plată",
        p: `Toate prețurile afișate pe site sunt exprimate în lei (RON) și ${C.vat_payer ? `includ TVA ${C.vat_rate}%` : "nu includ TVA (firma este neplătitoare de TVA)"}.\n\nMetode de plată acceptate:\n• ${C.payments.join("\n• ")}\n\nFactura fiscală se emite electronic și se transmite prin email după confirmarea plății, conform OUG 28/1999.`,
      },
      {
        h: "4. Livrare",
        p: `Livrarea se face prin curier rapid în toată România. Costul livrării standard este de ${C.policies.shipping_cost.toFixed(2)} RON. Timpul de livrare estimat: 24–48 ore lucrătoare după confirmarea comenzii.\n\nDetalii complete în Politica de Livrare.`,
      },
      {
        h: "5. Dreptul de retur (denunțare unilaterală)",
        p: `Conform OUG 34/2014, Cumpărătorul – persoană fizică, având calitatea de consumator – are dreptul să se retragă din contract, fără penalități și fără invocarea unui motiv, în termen de ${C.policies.return_days} zile calendaristice de la primirea produsului. Detalii complete în Politica de Retur.`,
      },
      {
        h: "6. Garanție",
        p: `Toate produsele beneficiază de garanție legală de conformitate de ${C.policies.warranty_months} luni de la data livrării, conform OUG 140/2021. Detalii complete în Politica de Garanție.`,
      },
      {
        h: "7. Răspundere",
        p: `ANAIZA SHOP nu poate fi tras la răspundere pentru întârzieri în livrare cauzate de curier sau pentru situații de forță majoră. Fotografiile produselor au caracter informativ și pot prezenta mici diferențe față de produsul real.`,
      },
      {
        h: "8. Soluționarea litigiilor",
        p: `Orice litigiu va fi soluționat pe cale amiabilă. În cazul în care nu se ajunge la o înțelegere, Cumpărătorul se poate adresa:\n• ANPC – Soluționarea Alternativă a Litigiilor (SAL): anpc.ro/ce-este-sal/\n• Platforma europeană SOL (Soluționarea Online a Litigiilor): ec.europa.eu/consumers/odr\n• Instanțelor judecătorești competente din România.`,
      },
      {
        h: "9. Modificări",
        p: `ANAIZA SHOP își rezervă dreptul de a modifica oricând prezentele Termeni și Condiții. Modificările intră în vigoare la momentul publicării pe site. Recomandăm consultarea periodică a acestei pagini.`,
      },
    ],
  },

  "politica-de-confidentialitate": {
    title: "Politica de Confidențialitate (GDPR)",
    eyebrow: "Protecția datelor",
    description: "Cum colectăm, folosim și protejăm datele tale personale conform Regulamentului GDPR 679/2016.",
    sections: [
      {
        h: "1. Operatorul de date",
        p: `Operatorul datelor tale cu caracter personal este ${C.legal_name}, cu sediul în ${ADDR}, CUI ${C.cif}, înregistrată la Reg. Com. sub nr. ${C.reg_com}.\n\nDate de contact: ${C.contact.email} · ${C.contact.phone}`,
      },
      {
        h: "2. Date colectate",
        p: `Colectăm următoarele categorii de date:\n• Date de identificare: nume, prenume\n• Date de contact: email, telefon\n• Date de livrare: adresă, oraș, județ, cod poștal\n• Date tranzacționale: produse comandate, valori, metoda de plată\n• Date tehnice: adresă IP, tip browser, sistem de operare, pagini vizitate (prin cookie-uri)`,
      },
      {
        h: "3. Scopul prelucrării",
        p: `Folosim datele tale exclusiv pentru:\n• Procesarea și livrarea comenzilor\n• Emiterea facturilor (obligație legală)\n• Comunicarea privind starea comenzii\n• Suport client și soluționarea reclamațiilor\n• Îmbunătățirea experienței pe site\n• Marketing direct, doar cu acordul tău explicit`,
      },
      {
        h: "4. Temei legal",
        p: `Prelucrăm datele tale în baza:\n• Executării contractului de vânzare (art. 6 alin. 1 lit. b GDPR)\n• Îndeplinirii obligațiilor legale fiscale și contabile (art. 6 alin. 1 lit. c GDPR)\n• Interesului legitim de a îmbunătăți serviciile (art. 6 alin. 1 lit. f GDPR)\n• Consimțământului tău expres pentru marketing (art. 6 alin. 1 lit. a GDPR)`,
      },
      {
        h: "5. Durata stocării",
        p: `Datele tale sunt stocate atât cât este necesar:\n• Date contabile (facturi): 10 ani – obligație legală\n• Date cont utilizator: până la ștergerea contului\n• Date marketing: până la retragerea consimțământului\n• Cookie-uri: maxim 12 luni`,
      },
      {
        h: "6. Drepturile tale",
        p: `Conform GDPR ai următoarele drepturi:\n• Dreptul de acces la datele tale\n• Dreptul la rectificare (corectare)\n• Dreptul la ștergere („dreptul de a fi uitat")\n• Dreptul la restricționarea prelucrării\n• Dreptul la portabilitatea datelor\n• Dreptul de opoziție\n• Dreptul de a nu fi supus deciziilor automate\n• Dreptul de a-ți retrage consimțământul oricând\n• Dreptul de a depune plângere la ANSPDCP (www.dataprotection.ro)\n\nPentru exercitarea acestor drepturi, scrie-ne la ${C.contact.email}.`,
      },
      {
        h: "7. Destinatari ai datelor",
        p: `Putem transmite datele tale către:\n• Furnizori de servicii de plată (Stripe Payments Europe, Ltd.)\n• Curieri pentru livrare (Fan Courier, Sameday, Cargus, etc.)\n• Furnizori IT (hosting, email)\n• Autoritățile publice, atunci când este obligat prin lege`,
      },
      {
        h: "8. Transfer în afara UE",
        p: `Datele tale sunt stocate în UE. Anumite servicii (ex. Stripe, Google Analytics) pot transfera date în afara SEE, sub clauzele contractuale standard aprobate de Comisia Europeană sau în baza unor decizii de adecvare.`,
      },
      {
        h: "9. Securitate",
        p: `Implementăm măsuri tehnice și organizatorice adecvate pentru protejarea datelor: criptare TLS/HTTPS pentru toate datele transmise, parole stocate cu bcrypt, acces restricționat la baza de date, copii de siguranță periodice.`,
      },
    ],
  },

  "politica-de-cookies": {
    title: "Politica de Cookies",
    eyebrow: "Tehnologii",
    description: "Ce sunt cookie-urile, cum le folosim pe anaiza-shop.ro și cum le poți gestiona.",
    sections: [
      {
        h: "1. Ce sunt cookie-urile?",
        p: `Cookie-urile sunt fișiere mici de tip text stocate de browser-ul tău la vizitarea unui site. Acestea permit recunoașterea utilizatorului la revenire și asigură funcționarea corectă a site-ului.`,
      },
      {
        h: "2. Cookie-uri folosite de ANAIZA SHOP",
        p: `Folosim doar cookie-uri strict necesare funcționării site-ului:\n\n• anaiza_token – stochează token-ul de autentificare (după login). Durata: 7 zile.\n• anaiza_cart_v1 – stochează produsele din coșul tău. Durata: nedeterminată (până la golirea coșului).\n• anaiza_cookie_consent_v1 – stochează preferința ta privind cookie-urile. Durata: 12 luni.\n\nNu folosim cookie-uri terțe pentru marketing sau remarketing.`,
      },
      {
        h: "3. Cookie-uri analitice",
        p: `Dacă ai acceptat cookie-urile prin banner, putem folosi pe viitor instrumente de analiză (ex. Plausible, Matomo, Google Analytics) pentru a înțelege cum este folosit site-ul. Aceste date sunt anonime și agregate.`,
      },
      {
        h: "4. Gestionare",
        p: `Poți gestiona cookie-urile direct din browser:\n• Chrome: Setări › Confidențialitate și securitate › Cookie-uri\n• Firefox: Setări › Confidențialitate și securitate\n• Safari: Preferințe › Confidențialitate\n\nDezactivarea cookie-urilor strict necesare poate afecta funcționarea coșului de cumpărături și a autentificării.`,
      },
      {
        h: "5. Contact",
        p: `Pentru orice întrebare despre politica de cookies, scrie-ne la ${C.contact.email}.`,
      },
    ],
  },

  "politica-de-retur": {
    title: "Politica de Retur",
    eyebrow: "Dreptul de retragere",
    description: `Returnezi produsele în termen de ${C.policies.return_days} zile, fără penalități, conform OUG 34/2014.`,
    sections: [
      {
        h: "1. Dreptul legal de retur",
        p: `Conform OUG 34/2014, Cumpărătorul – persoană fizică, având calitatea de consumator – are dreptul să se retragă din contract, fără penalități și fără invocarea unui motiv, în termen de ${C.policies.return_days} zile calendaristice de la primirea produsului.`,
      },
      {
        h: "2. Condiții de retur",
        p: `Pentru ca returul să fie acceptat:\n• Produsul trebuie returnat în starea originală, nefolosit, fără urme de uzură\n• Ambalajul original trebuie să fie intact (cutie, folii de protecție, plicuri de garanție)\n• Toate accesoriile, manualele și certificatele trebuie incluse\n• Produsul nu trebuie să prezinte zgârieturi sau deteriorări produse după livrare\n\nÎn cazul cuțitelor: lamele trebuie să nu fi fost folosite pentru tăiere – returnăm doar cuțite în ambalajul original, sigilat.`,
      },
      {
        h: "3. Procedura de retur",
        p: `Pasul 1: Trimite o cerere scrisă pe email la ${C.contact.email}, cu subiectul „RETUR Comandă #XXXXXXXX", menționând numărul comenzii și produsul returnat.\nPasul 2: Vei primi un formular de retur și instrucțiuni privind expedierea.\nPasul 3: Trimiți produsul pe adresa: ${ADDR}.\nPasul 4: După verificarea produsului, rambursarea se face în maxim 14 zile, prin aceeași metodă de plată folosită inițial.`,
      },
      {
        h: "4. Costuri de retur",
        p: `Costurile de returnare a produsului sunt suportate de Cumpărător, cu excepția cazurilor în care produsul este defect sau nu corespunde descrierii, când costurile sunt acoperite de ANAIZA SHOP.`,
      },
      {
        h: "5. Excepții",
        p: `Conform OUG 34/2014 art. 16, dreptul de retragere NU se aplică pentru:\n• Produse personalizate sau confecționate la comandă\n• Produse sigilate care nu pot fi returnate din motive de igienă, după desigilare\n• Produse care, prin natura lor, sunt amestecate cu alte bunuri după livrare`,
      },
      {
        h: "6. Rambursare",
        p: `Rambursarea se face prin aceeași metodă de plată folosită inițial:\n• Plată cu cardul: refundul se procesează prin Stripe în 5–10 zile lucrătoare\n• Plată ramburs: transfer bancar pe contul indicat de Cumpărător în formularul de retur`,
      },
    ],
  },

  "politica-de-livrare": {
    title: "Politica de Livrare",
    eyebrow: "Curier rapid",
    description: "Livrare națională rapidă în 24–48h prin curier. Detalii cost, timpi și termeni.",
    sections: [
      {
        h: "1. Zona de livrare",
        p: `Livrăm în toată România prin curier rapid. Pentru livrări în afara țării, contactează-ne pe ${C.contact.email} pentru o ofertă personalizată.`,
      },
      {
        h: "2. Termen de livrare",
        p: `Comanda este procesată în maxim 24 ore de la confirmare (zile lucrătoare). Livrarea de la curier durează:\n• 24–48 ore lucrătoare în zonele urbane principale\n• 2–4 zile lucrătoare pentru localități rurale\n\nComenzile plasate vineri după ora 14:00 sau în weekend se procesează luni.`,
      },
      {
        h: "3. Cost livrare",
        p: `Tariful standard de livrare este de ${C.policies.shipping_cost.toFixed(2)} RON pentru toate comenzile, indiferent de greutate sau dimensiune.${C.policies.free_shipping_threshold ? `\n\nLivrare GRATUITĂ pentru comenzi de peste ${C.policies.free_shipping_threshold} RON.` : ""}`,
      },
      {
        h: "4. Recepția coletului",
        p: `Toate coletele se livrează cu opțiunea „deschiderea coletului la livrare" – ai dreptul să verifici produsul în prezența curierului înainte de a semna AWB-ul. Dacă observi deteriorări, refuzi coletul și ne anunți la ${C.contact.email}.`,
      },
      {
        h: "5. Adresa de livrare",
        p: `Asigură-te că adresa, numele și telefonul introduse la checkout sunt corecte. Pentru reexpediere din cauza unei adrese greșite, costurile suplimentare cad în sarcina Cumpărătorului.`,
      },
      {
        h: "6. Curieri folosiți",
        p: `Colaborăm cu principalii curieri din România: Fan Courier, Sameday, Cargus, DPD. Numărul AWB pentru tracking se transmite prin email și SMS imediat după predarea la curier.`,
      },
    ],
  },

  "politica-de-garantie": {
    title: "Politica de Garanție",
    eyebrow: "Conformitate OUG 140/2021",
    description: `Garanție legală de ${C.policies.warranty_months} luni pentru toate produsele, conform legislației române.`,
    sections: [
      {
        h: "1. Garanția legală de conformitate",
        p: `Toate produsele comercializate de ANAIZA SHOP beneficiază de garanție legală de conformitate de ${C.policies.warranty_months} luni de la data livrării către Cumpărător, conform OUG 140/2021.`,
      },
      {
        h: "2. Ce acoperă garanția",
        p: `Garanția acoperă defectele de fabricație sau lipsa conformității cu descrierea produsului. În cazul unui produs defect, ai dreptul la:\n• Repararea gratuită a produsului\n• Înlocuirea cu un produs identic\n• Reducerea proporțională a prețului\n• Rezilierea contractului și rambursarea integrală\n\nAceste opțiuni se aplică gradual, în ordinea expusă mai sus, în funcție de natura defectului.`,
      },
      {
        h: "3. Ce NU acoperă garanția",
        p: `Garanția nu se aplică pentru:\n• Uzura normală în urma utilizării\n• Deteriorări cauzate de utilizare necorespunzătoare sau improprie scopului\n• Defecte cauzate de șocuri mecanice, cădere, contact cu lichide\n• Modificări sau reparații efectuate de persoane neautorizate\n• Pierderea ascuțirii lamelor de cuțit (consumabil) după utilizare normală — recomandăm achiziționarea ascuțitorului din magazin`,
      },
      {
        h: "4. Cum activezi garanția",
        p: `Pasul 1: Scrie-ne pe ${C.contact.email} cu subiectul „GARANȚIE Comandă #XXXXXXXX", descriind defectul și atașând poze/video.\nPasul 2: Echipa noastră analizează cazul și îți răspunde în maxim 48 ore lucrătoare.\nPasul 3: Dacă defectul intră sub garanție, organizăm preluarea produsului prin curier (gratuit pentru tine).\nPasul 4: Decizia finală (reparație, înlocuire, rambursare) se comunică în max 15 zile de la primirea produsului.`,
      },
      {
        h: "5. Excluderi specifice",
        p: `Cuțitele NU se spală în mașina de spălat vase. Spălarea în mașină duce la pierderea garanției pentru lamă și mâner.\nUneltele din truse sunt destinate uzului casnic, nu industrial; folosirea în regim profesional intensiv poate scurta durata de viață.`,
      },
    ],
  },

  "informatii-plati": {
    title: "Informații despre Plăți",
    eyebrow: "Metode de plată",
    description: "Plătești în siguranță prin Stripe sau ramburs la livrare. Toate prețurile în RON, cu TVA inclus.",
    sections: [
      {
        h: "1. Metode de plată acceptate",
        p: `• Card bancar – Visa, Mastercard, Maestro – procesat prin Stripe Payments Europe Ltd. (Irlanda)\n• Ramburs la livrare (cash sau card la curier) – disponibil în toată România`,
      },
      {
        h: "2. Securitatea plăților cu cardul",
        p: `Plățile cu cardul sunt procesate exclusiv prin Stripe – unul dintre cei mai mari procesatori de plăți din lume, certificat PCI-DSS Level 1. ANAIZA SHOP NU stochează datele cardului tău – întreaga tranzacție se desfășoară pe servere Stripe criptate.\n\nToate plățile sunt protejate prin standardul 3-D Secure (Verified by Visa, Mastercard SecureCode).`,
      },
      {
        h: "3. Moneda și TVA",
        p: `Toate prețurile sunt exprimate în lei (RON) și ${C.vat_payer ? `includ TVA ${C.vat_rate}%` : "nu includ TVA"}. Pe factură se evidențiază distinct valoarea fără TVA, TVA-ul și totalul.`,
      },
      {
        h: "4. Factura fiscală",
        p: `Factura fiscală se emite electronic, în format PDF, și se trimite prin email la maxim 24 ore după confirmarea plății. Factura este conformă cu OUG 28/1999 și OG 92/2003.\n\nPentru factură pe firmă (persoană juridică), introdu CUI-ul firmei și denumirea legală în câmpul „Mențiuni" la checkout.`,
      },
      {
        h: "5. Ramburs la livrare",
        p: `Plata ramburs se face curierului la primirea produsului. Suma achitată include și costul livrării. La unele curierese poate aplica o taxă suplimentară de ramburs (max. 2–3 RON), comunicată transparent.`,
      },
      {
        h: "6. Rambursări",
        p: `Pentru rambursări în cazul returului sau anulării comenzii:\n• Plată cu card: refund prin Stripe în 5–10 zile lucrătoare, pe același card\n• Plată ramburs: transfer bancar pe contul indicat de Cumpărător, în maxim 14 zile\n\nNu se aplică taxe suplimentare la rambursare.`,
      },
      {
        h: "7. Probleme cu plata",
        p: `Dacă plata eșuează sau ai dubii privind o tranzacție:\n• Verifică limita zilnică a cardului\n• Verifică dacă banca ta acceptă plăți online\n• Contactează emitentul cardului\n• Scrie-ne pe ${C.contact.email} cu detalii — te ajutăm imediat`,
      },
    ],
  },
};
